import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0.5rem 0 0.5rem 1.8rem;
`;

export const StyledTable = styled.table`
  border: 0.1rem solid ${({ theme }) => theme.colors.divider};
  border-collapse: collapse;
  width: 100%;
`;

export const StyledRow = styled.tr`
  height: 3rem;
`;

export const StyledColumn = styled.td<{ $isModal?: boolean }>`
  border: 0.1rem solid ${({ theme }) => theme.colors.divider};
  color: ${({ theme }) => theme.colors.text.main};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  text-align: center;
  vertical-align: middle;
  width: 50%;
  min-width: 50%;

  &:nth-child(odd) {
    width: ${({ $isModal }) => ($isModal ? '30rem' : 'fit-content')};
    padding-right: 1rem;
  }

  &:nth-child(even) {
    width: ${({ $isModal }) => ($isModal ? '21.5rem' : 'auto')};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    &:nth-child(odd),
    &:nth-child(even) {
      width: 50%;
    }
  }
`;

export const StyledTableContainer = styled.div<{ $isModal?: boolean }>`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: ${({ $isModal }) => $isModal && '37rem'};
  min-width: 50rem;
  width: ${({ $isModal }) => ($isModal ? '100%' : 'max-content')};

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    min-width: auto;
    overflow-x: auto;
    max-height: ${({ $isModal }) => $isModal && '30rem'};
    width: 100%;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    max-height: ${({ $isModal }) => $isModal && '35rem'};
  }
`;

export const StyledWriteupLink = styled.a`
  color: ${({ theme }) => theme.colors.info.main};
  text-decoration: none;
  display: block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  text-align: left;
  padding: 0.5rem 0 0.5rem 1.8rem;
`;
